import { EmptyInstance } from "core/features/components/mixins/empty-instance";
import { EventEmitterMixin } from "front-end/mixins/event-emitter.mixin";

export class SearchTextbox extends EventEmitterMixin(EmptyInstance) {
    public static SELECTOR = ".js-ina-search-textbox";

    private _classMap = {
        css: {
            show: "show",
            hidden: "hidden"
        },
        js: {
            input: `${SearchTextbox.SELECTOR}__input`,
            submitBtn: `${SearchTextbox.SELECTOR}__submit-btn`
        }
    };

    private _currentContext: JQuery = $();

    private _input: JQuery = null;
    private _submitBtn: JQuery = null;

    public getValue(): string {
        return this._input.val() as string;
    }

    public getName(): string {
        return this._input.attr("name");
    }

    public get isOpened(): boolean {
        return this._currentContext.hasClass(this._classMap.css.show);
    }

    public open(): void {
        this._currentContext.removeClass(this._classMap.css.hidden);
        this._currentContext.addClass(this._classMap.css.show);
        this._input.focus();
    }

    public close(): void {
        this._input.removeClass(this._classMap.css.show);
    }

    public show(): void {
        this._currentContext.show();
    }

    public hide(): void {
        this._currentContext.hide();
    }

    private bindEvents(): void {
        this._submitBtn.on("click", e => {
            e.preventDefault();
            this.emit("submit", this.getValue());
        });
        this._input.on("keypress", e => {
            if (e.key === "Enter") {
                e.preventDefault();
                this.emit("submit", this.getValue());
            }
        });
    }

    private parseContext(): void {
        this._input = $(this._classMap.js.input, this._currentContext);
        this._submitBtn = $(this._classMap.js.submitBtn, this._currentContext);
    }

    public init(context: JQuery): void {
        this._currentContext = context || this._currentContext;

        this.parseContext();
        this.bindEvents();
    }
}
